import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from "react-chartjs-2"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { convertBytesUnit, printFormattedBytes } from "helpers/common";

ChartJS.register(ArcElement, Tooltip, Legend);

const StorageChart = ({ storageDetails }) => {
  const totalStorageAvailable = convertBytesUnit(storageDetails?.total_storage_available || 0, "mb", "bytes");
  const storageUtilized = convertBytesUnit(storageDetails?.storage_used || 0, "mb", "bytes");
  const storageRemaining = convertBytesUnit(storageDetails?.storage_remaining || 0, "mb", "bytes");
  console.log("storageRemaining", storageRemaining, totalStorageAvailable, storageUtilized)

  const data = {
    labels: ['Utilized Storage Space', 'Storage Remaining'],
    datasets: [
      {
        label: 'Storage Usage',
        data: [storageUtilized, storageRemaining],
        backgroundColor: [
          '#ff9882',
          '#b0d6e8'
        ],
        borderColor: '#ffffff',
        borderWidth: 5,
        borderRadius: 10,
      },
    ],
  };

  const options = {
    cutout: '50%',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = tooltipItem.raw;
            return value ? printFormattedBytes(value) : "0.00 MB";
          }
        }
      },
      datalabels: {
        color: '#222',
        font: {
          weight: 'bold',
          size: 12
        },
        textShadowBlur: 4,
        textShadowColor: 'rgba(0, 0, 0, 0.5)',
        formatter: (value) => value ? printFormattedBytes(value) : "0.00 MB",
        textStrokeColor: "rgba(255, 255, 255, 0.8)",
        textStrokeWidth: 1,
      }
    }
  };

  return (
    <div className="pb-3">
      <Doughnut
        data={data}
        options={options}
        plugins={[ChartDataLabels]}
        height={300}
      />
    </div>
  )
}

export default StorageChart;
